import Vue from 'vue';
import Vuex from 'vuex';
import * as Web3Utils from 'web3-utils';
import { omit } from 'lodash'
import createPersistedState from 'vuex-persistedstate';
import ExternalService from './modules/ExternalService';
import MasterFeature from './modules/Master';
import OwnerFeature from './modules/Owner';
import MemberFeature from './modules/Member';
import TokenFeature from './modules/Token';
import VotingFeature from './modules/Voting';
import OraclizeFeature from './modules/Oraclize';
import FinancialStatementFeature from './modules/FinancialStatement';
import CompanyWalletFeature from './modules/CompanyWallet';
import LegalDocumentFeature from './modules/LegalDocument';
import CompanyDataFeature from './modules/CompanyData';
import MarketFeature from './modules/Market';
import EscrowFeature from './modules/Escrow';
import BalManagerFeature from './modules/Balance';
import { ABI } from './ABI';
// @ts-ignore
import { icons } from '@/constants/sidebarIcons';
// @ts-ignore
import ipfsAPI from '@/helpers/ipfs';
// @ts-ignore
import { chartData } from '@/helpers/chart';
// @ts-ignore
import CONFIG from '@/config';
import { communications } from '../helpers/communications';
import { mails } from '../helpers/mails';
import { defaultFormData } from '@/constants/sidebarData';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

async function contract() {
  return new Promise(resolve => {
    let contract = new window.web3.eth.Contract(ABI, state.masterAddress);
    resolve(contract);
  });
}

const initialState = {
  openClose: false,
  feature: {
    address: null,
    version: null,
    enabled: false
  },
  mailPending: [],
  pendings: {
    initialization: {
      update: false
    },
    member: {
      update: false
    },
    newMemberApprove: {
      id: null
    },
    voting: {
      new: false,
      resolve: {}
    },
    vote: {
      id: null
    },
    transferToken: {
      new: false
    },
    ordering: {
      new: false
    },
    trade: {
      id: null
    },
    cancelOrder: {
      id: null
    },
    escrowTransfer: {
      id: null
    },
    escrowTrade: {
      id: null
    },
    companyInfo: {
      update: false
    },
    companyTreasuryWallet: {
      new: false
    },
    companyUpdate: {
      new: false
    },
    legalDocument: {
      new: false
    },
    finStatement: {
      update: false
    },
    companyWalletEth: {
      update: false
    },
    companyWalletBtc: {
      update: false
    },
    companyWalletBank: {
      update: false
    }
  },
  sidebarForm: {
    title: '',
    descr1: '',
    descr2: '',
    form: {
      elements: [],
      submit (data) {},
      reset () {}
    }
  }
};

const state = {
  masterAddress: Web3Utils.toChecksumAddress(CONFIG.masterAddress),
  openClose: initialState.openClose,
  features: {
    ExternalService: initialState.feature,
    MasterFeature: initialState.feature,
    OwnerFeature: initialState.feature,
    MemberFeature: initialState.feature,
    TokenFeature: initialState.feature,
    VotingFeature: initialState.feature,
    OraclizeFeature: initialState.feature,
    FinancialStatementFeature: initialState.feature,
    CompanyWalletFeature: initialState.feature,
    LegalDocumentFeature: initialState.feature,
    CompanyDataFeature: initialState.feature,
    MarketFeature: initialState.feature,
    EscrowFeature: initialState.feature,
    BalManagerFeature: initialState.feature
  },
  mailPending: initialState.mailPending,
  pendings: initialState.pendings,
  sidebarForm: initialState.sidebarForm,
  sidebarLinks: [
    {
      link: '/',
      iconSvg: icons.home,
      name: 'home',
      isHidden: true
    },
    {
      link: '/shareholder',
      iconSvg: icons.shareholders,
      name: 'shareholders',
      isHidden: true
    },
    {
      link: '/voting',
      iconSvg: icons.voting,
      name: 'voting',
      isHidden: true
    },
    {
      link: '/financials',
      iconSvg: icons.financial,
      name: 'financials',
      isHidden: true
    },
    {
      link: '/marketplace',
      iconSvg: icons.marketplace,
      name: 'marketplace',
      isHidden: true
    },
    {
      link: '/legal',
      iconSvg: icons.legal,
      name: 'legal',
      isHidden: true
    },
    {
      link: '/permission',
      iconSvg: icons.approvals,
      name: 'communication',
      isHidden: true
    },
    {
      link: '/escrow',
      iconSvg: icons.notification,
      name: 'escrow',
      isHidden: false
    }
  ]
};

const getters = {
  getMasterAddress: state => state.masterAddress,
  getSidebarLinks: state => state.sidebarLinks,
  getFeatures: state => state.features,
  getFeatureAddress: state => name => state.features[name].address,
  getOpenClose: state => state.openClose,
  getPendings: state => state.pendings,
  getMailPending: state => state.mailPending,
  sidebarForm: (state) => state.sidebarForm,
  sidebarFormData: (state) => state.sidebarForm.form,
  ipfs: (state, getters) => ipfsAPI(getters.getWallet, getters.getMemberKey),
  chartData: (state, getters) => chartData(getters.getHeaders),
  communications: (state, getters) => communications(getters.getHeaders),
  mails: (state, getters) => mails(getters.getHeaders)
};

const mutations = {
  setFeature: (state, item) => {
    state.features = Object.assign(state.features, item);
  },
  setOpenClose: (state, item) => {
    state.openClose = item;
  },
  initializationPending: (state, item) => {
    state.pendings.initialization.update = item;
  },
  newVotingPending: (state, item) => {
    state.pendings.voting.new = item;
  },
  newVotePending: (state, item) => {
    state.pendings.vote.id = item;
  },
  newTradePending: (state, item) => {
    state.pendings.trade.id = item;
  },
  newCancelOrderPending: (state, item) => {
    state.pendings.cancelOrder.id = item;
  },
  newOrderPending: (state, item) => {
    state.pendings.ordering.new = item;
  },
  updateMemberPending: (state, item) => {
    state.pendings.member.update = item;
  },
  approveMemberPending: (state, item) => {
    state.pendings.newMemberApprove.id = item;
  },
  transferTokenPending: (state, item) => {
    state.pendings.transferToken.new = item;
  },
  companyInfoPending: (state, item) => {
    state.pendings.companyInfo.update = item;
  },
  companyTreasuryWalletPending: (state, item) => {
    state.pendings.companyTreasuryWallet.new = item;
  },
  companyUpdatePending: (state, item) => {
    state.pendings.companyUpdate.new = item;
  },
  legalDocumentPending: (state, item) => {
    state.pendings.legalDocument.new = item;
  },
  finStatementPending: (state, item) => {
    state.pendings.finStatement.update = item;
  },
  companyWalletEthPending: (state, item) => {
    state.pendings.companyWalletEth.update = item;
  },
  companyWalletBtcPending: (state, item) => {
    state.pendings.companyWalletBtc.update = item;
  },
  companyWalletBankPending: (state, item) => {
    state.pendings.companyWalletBank.update = item;
  },
  setEscrowTransferTokenPending: (state, item) => {
    state.pendings.escrowTransfer.id = item;
  },
  setEscrowTradePending: (state, item) => {
    state.pendings.escrowTrade.id = item;
  },
  setMailPending: (state, item) => {
    state.mailPending.push(item);
  },
  setSideBarFormData: (state, item) => {
    state.sidebarForm = item;
  },
  setSideBarFormModel: (state, item) => {
    state.sidebarForm.form.elements.map(el => {
      if (el.data.name === item.name) {
        if ('value' in el.data) {
          el.data.value = item.model;
        } else {
          el.data.model = item.model;
        }
      }
      return el;
    });
  },
  setSideBarFormDataValue: (state, item) => {
    state.sidebarForm.form.elements.map(el => {
      if (el.data.name === item.name) {
        if (el.data[item.prop]) {
          el.data[item.prop] = item.value;
        }
      }
      return el;
    });
  },
  setSideBarFormHasError: (state, item) => {
    state.sidebarForm.form.elements.map(el => {
      if (el.data.name === item.name) {
        el.data['hasError'] = item.value;
      }
      return el;
    });
  },
  setSideBarFormSubmit: (state, submit) => {
    Object.assign(state.sidebarForm.form, {submit});
  },
  resetMailPending: (state, item) => {
    state.mailPending = state.mailPending.filter(pending => pending !== item);
  }
};

const actions = {
  async init({ dispatch, commit, getters }) {
    await dispatch('getFeaturesDapp');
    let features = getters.getFeatures;
    for (let name in features) {
      dispatch('init' + name);
    }
    commit('initializationPending', false);
  },
  resetStates({ commit, getters }) {
    let features = getters.getFeatures;
    for (let name in features) {
      // Prevent chart from store reset
      if (name === 'MarketFeature') continue;
      commit('reset' + name);
    }
  },
  openClose({ getters, commit }) {
    commit('setOpenClose', !getters.getOpenClose);
  },
  closeSidebar({ commit }) {
    commit('setOpenClose', false);
  },
  async getFeaturesDapp({ getters, commit, dispatch }) {
    let arr = getters.getFeatures;
    let features = omit(arr, 'ExternalService', 'MasterFeature');

    for (let name in features) {
      await getFeatureDapp(name);
    }
    async function getFeatureDapp(name) {
      await contract()
        .then((contract: any) => {
          return new Promise((resolve, reject) => {
            contract.methods.getFeature(name)
              .call()
              .then(res => {
                let obj = Object.assign({}, initialState.feature);
                if (res) {
                  obj.address = res[0];
                  obj.version = res[1];
                  obj.enabled = true;
                }
                let newObj = {};
                newObj[name] = obj;
                return resolve(newObj);
              })
              .catch(err => reject(err));
          });
        })
        .then(res => {
          commit('setFeature', res);
        })
        .catch(err => console.log(err));
    }
  },
  setSideBarForm({commit}, sidebarForm: any) {
    commit('setSideBarFormData', sidebarForm);
  }
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    ExternalService,
    MasterFeature,
    OwnerFeature,
    MemberFeature,
    TokenFeature,
    VotingFeature,
    OraclizeFeature,
    FinancialStatementFeature,
    CompanyWalletFeature,
    LegalDocumentFeature,
    CompanyDataFeature,
    MarketFeature,
    EscrowFeature,
    BalManagerFeature
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ],
  strict: debug
});
